/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // 内容模板配置
  Template: () => import(/* webpackChunkName: "dict" */ '@/views/page/Template/index')
};

export const TemplateRoute = [
  {
    path: '/Template',
    component: Layout,
    redirect: { name: 'Template' },
    isMenu: true,
    children: [
      {
        path: 'index',
        name: 'Template',
        component: routes['Template'],
        meta: { title: '内容模板配置', icon: 'menu_template'}
      }
    ]
  }
];
